import { ChangeEventHandler, useEffect, useState } from "react";
import Header from "../components/Header";
import ScanModal from "../components/ScanModal";
import { useCommonUtil } from "../util/useCommonUtil";
import "./scss/driverInfo.scss";
import { rootReducer } from "../store/store";
import { useDispatch, useSelector } from "react-redux";
import SvgIcon from "@mui/material/SvgIcon";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import KeyboardWrap from "../components/Keyboard";
import * as hangul from "hangul-js";
import LisenceSelect from "../components/LisenceSelect";
import { useHistory } from "react-router-dom";
import { driver } from "../actions/authActions";
import {
  defaultDriver,
  Driver,
  DriverInfo,
  DriverValidResponse,
  DriverValidTypes,
  initialDriverInfo
} from "../types/DriverTypes";
import AdminLicenseCheckModal from "../components/AdminLicenseCheckModal";
import AlertModal from "../components/AlertModal";
import ConfirmModal from "../components/ConfirmModal";
import {
  AlertType,
  AdminLicenseCheckAlertType,
  KeyboardInputType,
  KeyboardType,
  alertType,
  equlesDlvLicenseValid,
  keyboardInputInit,
  keyboardTypeInit,
  validationItems
} from "../types/CommonType";
import axios, { AxiosResponse } from "axios";
import axiosInstance from "../api/axiosInstance";
import moment from "moment";
import { isNeedCheckLicense, generateAdminCheckPopContent } from "../validators/driverValidators";
import AdminKeyboard from "../components/AdminKeyboard";

declare global {
  interface Window {
    addLicenseFileInfo: any; // 원하는 타입으로 설정
  }
}
type AuthState = ReturnType<typeof rootReducer>;

const adminKeyboardBasic = {
  adminLoginShow: false,
  admingLoginKeyboardShow: false,
  keyboardShow: false
}

const DriverInfo1: React.FC = () => {
  window.addLicenseFileInfo = addLicenseFileInfo;

  const history = useHistory();
  const dispatch = useDispatch();
  const {
    formatDate,
    formatLicenseType,
    licneseAlertMsg,
    formatLicenseName,
    formatPhoneNumber,
    addHyphenToLicenseNumber,
    formatBirthDaySummary,
    parsingLicenseIssuedYear
  } = useCommonUtil();

  const [adminKeyboard, setAdminKeyboard] = useState(adminKeyboardBasic);
  const [alertInfo, setAlertInfo] = useState<AlertType>(alertType);
  const [adminLicenseCheckAlertInfo, setAdminLicenseCheckAlertInfo] = useState<AdminLicenseCheckAlertType>({
    title: "",
    content: "",
    show: false
  });
  const [driver2ConfirmShow, setDriver2ConfirmShow] = useState<boolean>(false);
  
  const [modalTitle, setModalTitle] = useState<string>("관리자 조회 실패");
  const [modalContent, setModalContent] = useState<string>("");
  const [modalShow, setModalShow] = useState<boolean>(false);

  const [keyboardInfo, setKeyBoardInfo] =
    useState<KeyboardType>(keyboardTypeInit);
  const [driverSelectShow, setDriverSelectShow] = useState<boolean>(false);
  const [keyboardInput, setKeyboardInput] =
    useState<KeyboardInputType>(keyboardInputInit);
  const [driverValue, setDriverValue] = useState<DriverInfo>({
    ...initialDriverInfo
  });
  let [hangulArr, setHangulArr] = useState<string[]>([]);
  const [layoutName, setLayoutName] = useState<string>("default");
  const [driverArr, setDriverArr] = useState<Driver[]>([...defaultDriver]);

  const resInfo = useSelector((state: AuthState) => state.store.resOneInfo);
  const driverPrev = useSelector((state: AuthState) => state.store.driver);

  const driverInfo = driverPrev && driverPrev.data;

  const data = resInfo && resInfo.data;
  const memberRegFlag = useSelector((state: AuthState) => state.store.memberRegFlag);

  /** 운전면허 OCR 스캔 시작 함수 (C# 통신) */
  const scanStart = async () => {
    const reservationId: HTMLInputElement | null = document.getElementById(
      "reservationId"
    ) as HTMLInputElement | null;

    if (reservationId) {
      reservationId.value = resInfo?.data.reservationId || "";
    }

    const licenseScanWaitStatus: HTMLInputElement | null =
      document.getElementById(
        "licenseScanWaitStatus"
      ) as HTMLInputElement | null;

    const kioskOperation: HTMLInputElement | null = document.getElementById(
      "kioskOperation"
    ) as HTMLInputElement | null;

    if (licenseScanWaitStatus) {
      licenseScanWaitStatus.value = "true";
    }

    if (kioskOperation) {
      kioskOperation.value = "LicenseScan";
    }

    // setDriverValue(prev => ({ ...prev, driverDirect: false }));
  };

  /** 스캔 모달 종료 함수 */
  const modalControl = () => {
    setDriverValue((prev) => ({ ...prev, driverDirect: true }));
    setModalShow(false);
  };

  /** OCR 스캔 완료 후 결과 값 받는 함수 (C# 통신) */
  function addLicenseFileInfo(param: any) {
    console.log("addLicenseFileInfo", param);
    const inputElement: HTMLInputElement | null = document.getElementById(
      "kioskRequestOperationParam"
    ) as HTMLInputElement | null;

    if (inputElement) {
      setDriverValue((prev) => ({
        ...prev,
        fileId: inputElement.value
      }));
    }

    const driverNameInput: HTMLInputElement | null = document.getElementById(
      "driverName[0]"
    ) as HTMLInputElement | null;

    const birthday: HTMLInputElement | null = document.getElementById(
      "birthday[0]"
    ) as HTMLInputElement | null;

    const licenseTypeInput: HTMLInputElement | null = document.getElementById(
      "licenseType[0]"
    ) as HTMLInputElement | null;

    const licenseNum: HTMLInputElement | null = document.getElementById(
      "licenseNum[0]"
    ) as HTMLInputElement | null;

    if (driverNameInput) {
      setDriverValue((prev) => ({
        ...prev,
        driverName: driverNameInput.value
      }));
    }

    if (birthday) {
      setDriverValue((prev) => ({
        ...prev,
        birthday: formatBirthDaySummary(birthday?.value)
      }));
    }
    if (licenseTypeInput) {
      setDriverValue((prev) => ({
        ...prev,
        licenseType: licenseTypeInput?.value
      }));
    }

    if (licenseNum) {
      setDriverValue((prev) => ({
        ...prev,
        licenseNum: addHyphenToLicenseNumber(licenseNum?.value)
      }));
    }

    // 주운전자 면허증 스캔 시, 주소 정보 받도록
    const address: HTMLInputElement | null = document.getElementById(
      "address[0]"
    ) as HTMLInputElement | null;
    
    if(address) {
      setDriverValue((prev) => ({ ...prev, address: address?.value }));
    }
    
    setDriverValue((prev) => ({
      ...prev,
      licenseFileList: [param]
    }));
    
    /** 면허 OCR 정보를 받아 온 값으로 운전면허 검증 API 호출 */
    const dlvRequest = {
      licenseNo: licenseNum?.value.replace(/-/g, ""),
      residentName: driverNameInput && driverNameInput?.value,
      residentDate: formatDate(driverValue.birthday),
      seqNo: "",
      licenseConCode: formatLicenseType(licenseTypeInput?.value),
      exportCarId: resInfo?.data.carId || 0,
      fromDate: data?.takeoverDtm as any,
      toDate: data?.returnDtm as any
    } as DriverValidTypes;

    console.log(dlvRequest.licenseNo && dlvRequest.residentName && dlvRequest.licenseConCode);
    if([
      dlvRequest.licenseNo,
      dlvRequest.residentName,
      dlvRequest.licenseConCode
      ].every(v => String(v ?? "").trim() !== "")){
        
      equlesDlvLicense(dlvRequest);
    }
  }

  const equlesDlvLicense = async (param: DriverValidTypes) => {
    console.log(param);
    try {
      const response = await axios.post<
        DriverValidTypes,
        AxiosResponse<DriverValidResponse>
      >(
        `${process.env.REACT_APP_MOBILE_API_URL}/V1/${data?.companyId}/DriverLicenseValidator.do`,
        param
      );

      if (response.data.result === "success") {
        // const currentDate = new Date();
        // const formattedDate = currentDate.toISOString().slice(0, 19).replace('T', ' ');
        setDriverValue((prev) => ({
          ...prev,
          licenseCerti: true,
          licenseCheckDtm: moment().format("YYYY-MM-DD HH:mm:ss")
        }));
      } else {
        if (response.data.message.includes("검증시스템에서")) {
          setDriverValue((prev) => ({
            ...prev,
            licenseCerti: true,
            licenseSystemError: true
          }));
          setAlertInfo({
            show: true,
            title: "면허 검증 시스템 장애",
            content:
              "면허 검증 시스템 오류로 인해<br/> 데스크에서 차키 수령시<br/>직원분이 면허정보를 추가 확인하게 됩니다."
          });
          return false;
        } else {
          setDriverValue((prev) => ({ ...prev, licenseCerti: false }));
          setAlertInfo({
            show: true,
            title: "면허 검증 실패",
            // content: response.data.message + '<br/> 운전자 정보를 다시 확인해주세요.',
            content: licneseAlertMsg(response.data.message || "")
          });
          return false;
        }
      }
    } catch (error) {
      console.error(error);
      setAlertInfo({
          show: true,
          title: "키오스크 시스템 에러",
          content: "에러가 발생했습니다.<br/>다시 시도해주세요."
      });
    }
  };

  /** 사용자 키보드 입력 함수 */
  const onKeyPress: ChangeEventHandler<HTMLElement> = (event) => {
    if (keyboardInfo.keyboardType === "text") {
      if (String(event) === "{shift}") {
        setLayoutName(layoutName === "default" ? "shift" : "default");
      } else if (String(event) === "{bksp}") {
        const removedPart = keyboardInput.keyboardInputValue?.slice(-1);

        setKeyboardInput((prev) => ({
          ...prev,
          keyboardInputValue: keyboardInput.keyboardInputValue?.slice(0, -1)
        }));
        const deleteArr = hangul.disassemble(removedPart || "");
        for (let i = deleteArr.length - 1; i >= 0; i--) {
          const lastIndex = hangulArr.lastIndexOf(deleteArr[i]);
          if (lastIndex !== -1) {
            hangulArr.splice(lastIndex, 1);
          }
        }
      } else {
        // 텍스트 입력 처리
        const newHangul = String(event); // 입력된 키의 텍스트 값
        hangulArr.push(newHangul); // 입력된 텍스트 값을 배열에 추가
        const newDriverValue = hangul.assemble(hangulArr); // 자음모음 합치기

        setKeyboardInput((prev) => ({
          ...prev,
          keyboardInputValue: newDriverValue
        }));
      }
    } else if (keyboardInfo.keyboardType === "number") {
      if (
        /^[a-zA-Z\uAC00-\uD7A3\u1100-\u11FF\u3130-\u318F\W_]+$/.test(
          String(event)
        )
      ) {
        if (String(event) === "{shift}") {
          setLayoutName(layoutName === "default" ? "shift" : "default");
        } else if (String(event) === "{bksp}") {
          const removedPart = keyboardInput.keyboardInputValue?.slice(-1);

          setKeyboardInput((prev) => ({
            ...prev,
            keyboardInputValue: keyboardInput.keyboardInputValue?.slice(0, -1)
          }));
          const deleteArr = hangul.disassemble(removedPart || "");
          for (let i = deleteArr.length - 1; i >= 0; i--) {
            const lastIndex = hangulArr.lastIndexOf(deleteArr[i]);
            if (lastIndex !== -1) {
              hangulArr.splice(lastIndex, 1);
            }
          }
        } else if (String(event) === "재입력") {
          setKeyboardInput((prev) => ({ ...prev, keyboardInputValue: "" }));
        } else if (String(event) === "지우기") {
          setKeyboardInput((prev) => ({
            ...prev,
            keyboardInputValue: prev.keyboardInputValue?.slice(0, -1)
          }));
        } else {
          // 텍스트 입력 처리
          const newHangul = String(event); // 입력된 키의 텍스트 값
          hangulArr.push(newHangul); // 입력된 텍스트 값을 배열에 추가
          const newDriverValue = hangul.assemble(hangulArr); // 자음모음 합치기
          setKeyboardInput((prev) => ({
            ...prev,
            keyboardInputValue: newDriverValue
          }));
        }
      } else if (String(event) === "재입력") {
        setKeyboardInput((prev) => ({ ...prev, keyboardInputValue: "" }));
        setDriverValue((prev) => ({
          ...prev,
          [keyboardInput.keyboardTypeName]: (prev[
            keyboardInput.keyboardTypeName
          ] = "")
        }));
      } else if (String(event) === "지우기") {
        setKeyboardInput((prev) => ({
          ...prev,
          keyboardInputValue: prev.keyboardInputValue?.slice(0, -1)
        }));
        setDriverValue((prev) => ({
          ...prev,
          [keyboardInput.keyboardTypeName]: prev[
            keyboardInput.keyboardTypeName
          ].slice(0, -1)
        }));
      } else {
        if (
          keyboardInput.keyboardTypeName === "tel" ||
          keyboardInput.keyboardTypeName === "emContactNumber"
        ) {
          if (keyboardInput.keyboardInputValue.length >= 13) { // 11글자 + 하이픈(-) 2개 포함 검증
            return false;
          }
        } else if (keyboardInput.keyboardTypeName === "licenseNum") {
          if (keyboardInput.keyboardInputValue.length >= 15) { // 12글자 + 하이픈(-) 3개 포함 검증
            return false;
          }
        } else if (keyboardInput.keyboardTypeName === "birthday") {
          if (keyboardInput.keyboardInputValue.length >= 6) {
            return false;
          }
        }
        setKeyboardInput((prev) => ({
          ...prev,
          keyboardInputValue: prev.keyboardInputValue + event
        }));
      }
    }

    // 면허 검증 상태가 true여도 운전자 이름을 수정하면 관리자를 통하게 함
    if (
      keyboardInput.keyboardTypeName === "driverName" ||
      keyboardInput.keyboardTypeName === "licenseNum"
    ) {
      setDriverValue((prev) => ({ ...prev, driverDirect: true }));
    }
  };

  /** 면허 종류 선택 시 */
  const LisenceClick = (code: string) => {
    //기본 입력된 면허종류와 새로 입력된 면허종류가 다르면 관리자를 통하게 하고 면허 검증 false
    if (driverValue.licenseType !== code) {
      setDriverValue((prev) => ({
        ...prev,
        licenseCerti: false
      }));
      setDriverValue((prev) => ({ ...prev, driverDirect: true }));
    }
    setDriverValue((prev) => ({
      ...prev,
      licenseType: code
    }));

    setDriverSelectShow(false);
  };

  const selectOnClose = () => {
    setDriverSelectShow(false);
  };

  /** 사용자 키보드 입력 후 "확인" 버튼을 눌렀을 때 적용 함수 */
  const updateDriver = () => {
    // 기존에 입력했던 이름과 새로 입력한 이름이 다르면 면허 검증을 새로 받아야 함
    if (keyboardInput.keyboardTypeName === "driverName") {
      if (driverValue.driverName !== keyboardInput.keyboardInputValue) {
        setDriverValue((prev) => ({
          ...prev,
          licenseCerti: false
        }));
        setDriverValue((prev) => ({ ...prev, driverDirect: true }));
      }
      setDriverValue((prev) => ({
        ...prev,
        driverName: keyboardInput.keyboardInputValue
      }));
    }
    if (keyboardInput.keyboardTypeName === "birthday") {
      setDriverValue((prev) => ({
        ...prev,
        birthday: keyboardInput.keyboardInputValue
      }));
    }
    if (keyboardInput.keyboardTypeName === "licenseNum") {
      if (driverValue.licenseNum !== keyboardInput.keyboardInputValue) {
        setDriverValue((prev) => ({
          ...prev,
          licenseCerti: false
        }));
        setDriverValue((prev) => ({ ...prev, driverDirect: true }));
      }
      setDriverValue((prev) => ({
        ...prev,
        licenseNum: addHyphenToLicenseNumber(keyboardInput.keyboardInputValue)
      }));
    }
    if (keyboardInput.keyboardTypeName === "tel") {
      setDriverValue((prev) => ({
        ...prev,
        tel: formatPhoneNumber(
          keyboardInput.keyboardInputValue
        )
      }));
    }
    if (keyboardInput.keyboardTypeName === "emContactNumber") {
      setDriverValue((prev) => ({
        ...prev,
        emContactNumber: formatPhoneNumber(
          keyboardInput.keyboardInputValue
        )
      }));
    }
    setKeyboardInput((prev) => ({ ...prev, keyboardInputValue: "" }));

    hangulArr.splice(0, hangulArr.length);
    setKeyBoardInfo({ keyboardShow: false });
  };

  const validation = (driverParam: DriverInfo): boolean => {
    for (const item of validationItems) {
      const validationResult = item.validator
        ? item.validator(driverParam[item.field], data, driverParam)
        : true; // validator 함수가 없으면 항상 true 반환
      if (validationResult !== true) {
        // validator 함수의 반환값이 true가 아니라면 오류 처리
        const errorMessage =
          typeof validationResult === "string"
            ? validationResult
            : item.errorMessage;
        setAlertInfo((prev) => ({
          ...prev,
          show: true,
          title: "운전자 정보를 확인해주세요.",
          content: `${errorMessage}`
        }));
        return false;
      }
    }

    // 위 validationItems 에서 면허증 포멧 유효성 검사는 완료함으로, 아래 validator에선 따로 검사 X
    // 25.02.25. 면허 상 경력과 보험 가입 기준 경력이 같은 경우, 면허증 발급일자 현장 확인 필요
    driverValue.needCheckCareer = isNeedCheckLicense(driverParam, data);

    return true;
  };

  /** "인증" 버튼을 통한 면허 검증 */
  const directDlvLicense = () => {
    for (const item of equlesDlvLicenseValid) {
      if (!driverValue[item.field]) {
        setAlertInfo((prev) => ({
          ...prev,
          show: true,
          title: "운전자 정보를 확인해주세요.",
          content: `${item.errorMessage}`
        }));
        return false;
      }
    }
    console.log(driverValue.licenseType);
    const dlvRequest = {
      licenseNo: driverValue.licenseNum.replace(/-/g, ""),
      residentName: driverValue.driverName,
      residentDate: formatDate(driverValue.birthday),
      seqNo: "",
      licenseConCode: formatLicenseType(driverValue.licenseType),
      fromDate: data?.takeoverDtm as any,
      toDate: data?.returnDtm as any,
      exportCarId: data?.carId || 0
    };
    equlesDlvLicense(dlvRequest);
  };

  const driver2Regist = () => {
    console.log("driverArr", driverArr);
    console.log("driverInfo", driverInfo);

    // if (driverArr && driverArr[1]) {
    //   driverArr.pop();
    // }
    if (validation(driverValue)) {
      driverArr[0] = driverValue;
      driverArr[0].birthday = formatDate(driverArr[0].birthday || "");
      driverArr[0].memberRegFlag = !!memberRegFlag;

      // 사전에 등록된 부운전자 정보가 있다면 세팅
      setDriver2InfoIfExists();

      dispatch(driver(driverArr));

      console.log("driverArr", driverArr);
      history.push({
        pathname: "/driverInfo2",
        state: { 
          driver1Direct: driverValue.driverDirect,
          driver1NeedCheckCareer: driverValue.needCheckCareer // 25.02.25 면허증 현장 확인 필요 여부 추가
        }
      });
    }
  };

  const adminCheckPopCallback = async (data: any) => {
    try{
      await axiosInstance()
        .post(`/kiosk/adminSameCheck.do`, {
          companyId: resInfo?.data.companyId,
          userId: data.userId,
          userPassword: data.userPassword,
          kioskLoginPwd: data.userPassword,
        })
        .then((res) => {
          if (res.data.status === 400) {
            setModalContent(res.data.resultMsg);
            setModalShow(true);
            return false;
          } else {
            driverArr[0].isAdminManualCheck = true;
            driverArr[0].memberRegFlag = !!memberRegFlag;
            console.log(driverArr);
            dispatch(driver(driverArr));
            setDriverValue((prev) => ({ ...prev, isAdminManualCheck: true }));
            setAdminKeyboard((prev) => ({ ...prev, keyboardShow: false }));
            continueAfterPrimaryDriverCheck();
          }
        });
    } catch(error){
      console.log(error);

      setAlertInfo({
          show: true,
          title: "키오스크 시스템 에러",
          content: "에러가 발생했습니다.<br/>다시 시도해주세요.",
          callback: () => window.location.reload()
      });
    }
  }

  const proceedToNextStep = (adminChecked = false) => {
    if(driverValue.needCheckCareer && driverValue.needCheckCareer.length > 0 && !driverValue.isAdminManualCheck && !adminChecked) {
      const noticeMessage = generateAdminCheckPopContent(resInfo?.data || {}, driverValue);

      setAdminLicenseCheckAlertInfo({
        show: true,
        title: "면허증 확인 필요",
        content: "면허증 확인이 필요합니다. 직원에게 문의하세요." + noticeMessage,
        callback: () => {
          setAdminKeyboard(prev => ({ ...prev, keyboardShow: true,}));
        }
      });

      return;
    }

    if (driverValue.driverDirect && !driverValue.isAdminManualCheck && !adminChecked) {
      setAlertInfo({
        show: true,
        title: "관리자 확인 필요",
        content: "면허 정보를 직접 입력시, 인수할 때 관리자에게 면허증을 보여주세요.",
        callback: () =>
          resInfo?.data.preRegStatus === "N"
            ? history.push("/contract")
            : history.push("/addIns")
      });
      return;
    }

    resInfo?.data.preRegStatus === "N"
      ? history.push("/contract")
      : history.push("/addIns");
  };

  const NextButton = () => {
    if (driverArr && !driverArr[1] && !driverValue.emContactNumber) {
      setAlertInfo({
        show: true,
        title: "운전자 정보를 입력해주세요.",
        content: "비상 연락처를 입력해주세요."
      });
      return false;
    }
    
    if (validation(driverValue)) {
      driverArr[0] = driverValue;
      driverArr[0].birthday = formatDate(driverArr[0].birthday || "");
      driverArr[0].memberRegFlag = !!memberRegFlag;

      dispatch(driver(driverArr));

      // 사전에 등록된 부운전자 정보가 있다면 부운전자 정보 확인 유도
      // setDriver2InfoIfExists()
      if (driverValue.needCheckCareer && driverValue.needCheckCareer.length > 0 && !driverValue.isAdminManualCheck) {
        const noticeMessage = generateAdminCheckPopContent(resInfo?.data || {}, driverValue);

        setAdminLicenseCheckAlertInfo({
          show: true,
          title: "면허증 확인 필요",
          content: "면허증 확인이 필요합니다. 직원에게 문의하세요." + noticeMessage,
          callback: () => {
            setAdminKeyboard((prev) => ({ ...prev, keyboardShow: true }));
          }
        });
        return false;
      }

      if(resInfo?.data.preRegStatus === 'Y' && setDriver2InfoIfExists()) {
        setAlertInfo({
          show: true,
          title: "부운전자 정보 확인 필요",
          content: "사전에 등록된 부운전자 정보가 존재합니다.<br>부운전자 정보 확인 화면으로 이동합니다.",
          callback: () =>
            history.push({
              pathname: "/driverInfo2",
              state: { 
                driver1Direct: driverValue.driverDirect,
                driver1NeedCheckCareer: driverValue.needCheckCareer
              }
            })
        });
        return false;
      }

      if (!driverArr[1] && !(driverInfo && driverInfo[1])) {
        setDriver2ConfirmShow(true);
        return false;
      }

      proceedToNextStep();
    }
  };

  const setDriver2InfoIfExists = () => {
    if(driverInfo && driverInfo[1]) {
      const driver2nd = driverInfo[1];
      const driverSecond: DriverInfo = {
        companyId: resInfo?.data?.companyId || "",
        reservationId: String(resInfo?.data?.reservationId || ""),
        orderNum: 1,
        licenseCheckDtm: driver2nd.licenseCheckDtm,
        driverName: driver2nd?.driverName || "",
        tel: formatPhoneNumber(driver2nd?.tel || "") || "",
        emContactNumber: formatPhoneNumber(driver2nd?.emContactNumber || "") || "",
        birthday: formatDate(driver2nd?.birthday || "") || "",
        address: driver2nd?.address,
        licenseNum: driver2nd?.licenseNum || "",
        licenseType: driver2nd?.licenseType || "" || "",
        licenseCerti: !!driver2nd?.licenseCerti,
        fileId: driver2nd?.fileId || "",
        licenseFileGroupId: driver2nd?.licenseFileGroupId || "",
        driverDirect: driver2nd?.driverDirect,
        licenseFileList: driver2nd?.licenseFileList || [],
        needCheckCareer: driver2nd?.needCheckCareer || [],
        isAdminManualCheck: !!driver2nd?.isAdminManualCheck,
        memberRegFlag: !!memberRegFlag
      };
      driverArr.push(driverSecond);

      return true;
    }

    return false;
  }

  const continueAfterPrimaryDriverCheck = () => {
    if (resInfo?.data.preRegStatus === "Y" && setDriver2InfoIfExists()) {
      dispatch(driver(driverArr));
      history.push({
        pathname: "/driverInfo2",
        state: {
          driver1Direct: driverValue.driverDirect,
          driver1NeedCheckCareer: driverValue.needCheckCareer
        }
      });
      return;
    }

    if (!driverArr[1] && !(driverInfo && driverInfo[1])) {
      setDriver2ConfirmShow(true);
      return;
    }

    proceedToNextStep(true);
  };

  useEffect(() => {
    if (!driverInfo) {
      setModalShow(true);
    } else {
      const info = driverInfo[0];
      console.log("info ", driverInfo);
      console.log("driverValue", driverValue);
      setDriverValue({
        companyId: info?.companyId || "",
        reservationId: String(info?.reservationId),
        orderNum: 0,
        licenseCheckDtm: info?.licenseCheckDtm,
        driverName: info?.driverName || "",
        tel: formatPhoneNumber(info?.tel || "") || "",
        address: info?.address || "",
        emContactNumber: formatPhoneNumber(info?.emContactNumber || "") || "",
        birthday: formatDate(info?.birthday || "") || "",
        licenseNum: info?.licenseNum || "",
        licenseType: info?.licenseType || "" || "",
        licenseCerti: !!info?.licenseCerti,
        fileId: info?.fileId || "",
        licenseFileGroupId: info?.licenseFileGroupId || "",
        driverDirect: info?.driverDirect,
        licenseFileList: info?.licenseFileList || [],
        needCheckCareer: info?.needCheckCareer || [],
        isAdminManualCheck: !!info?.isAdminManualCheck,
        memberRegFlag: !!memberRegFlag
      });
      // setDirectDriver(!info?.licenseCerti);
    }

    setDriverValue((prevState) => ({
      ...prevState,
      companyId: resInfo?.data?.companyId || "",
      reservationId: String(resInfo?.data?.reservationId || ""),
      orderNum: 0
    }));
  }, [driverInfo]);
  return (
    <>
      <Header></Header>
      {adminLicenseCheckAlertInfo.show && (
        <AdminLicenseCheckModal
          callback={() => {
            if (adminLicenseCheckAlertInfo.callback) {
              adminLicenseCheckAlertInfo.callback();
            }
          }}
          onClose={() => {
            setAdminLicenseCheckAlertInfo((prev) => ({ ...prev, show: false }));
          }}
          title={adminLicenseCheckAlertInfo.title}
          content={adminLicenseCheckAlertInfo.content}
        ></AdminLicenseCheckModal>
      )}
      {alertInfo.show && (
        <AlertModal
          onClose={() => {
            if (alertInfo.callback) {
              alertInfo.callback(); // 콜백 함수 호출
            } else setAlertInfo((prev) => ({ ...prev, show: false }));
          }}
          title={alertInfo.title}
          content={alertInfo.content}
        ></AlertModal>
      )}
      <ConfirmModal
        isOpen={driver2ConfirmShow}
        title="부 운전자 등록"
        message="부 운전자를 등록하시겠습니까?"
        confirmMent="예"
        cancelMent="아니오"
        onCancel={() => {
          setDriver2ConfirmShow(false);
          proceedToNextStep();
        }}
        onConfirm={() => {
          setDriver2ConfirmShow(false);
          driver2Regist();
        }}
      ></ConfirmModal>
      {modalShow && (
        <ScanModal
          onDirectClick={() => {
            setDriverValue((prev) => ({ ...prev, driverDirect: true }));
            setModalShow(false);
          }}
          offDirectClick={() => {
            setDriverValue((prev) => ({ ...prev, driverDirect: false }));
          }}
          onClick={() => {
            scanStart();
          }}
          onClose={() => {
            modalControl();
          }}
        ></ScanModal>
      )}
      <div className="driver-wrap">
        <div className="driver-title-wrap">
          <span>주 운전자</span>

          <div className="rent-dec">
            <>
              만 {data?.rentCondAge}세, 운전경력 {data?.rentCondLicenseYear}년
              이상 운전자만 차량 대여가 가능합니다.
            </>
          </div>
        </div>
        <div className="driver-info-wrap">
          <div className="lisence-wrap">
            <div className="img-wrap">
              {driverValue.fileId ? (
                <img
                  src={`${
                    process.env.REACT_APP_DOMAIN
                  }/Common/File/Download.do?fileId=${
                    driverValue.fileId
                      ? driverValue.fileId
                      : driverArr[0].fileId
                  }`}
                  alt="img"
                />
              ) : (
                <div className="no-img">이미지 없음</div>
              )}
            </div>

            <div className="refresh-wrap" onClick={() => setModalShow(true)}>
              <SvgIcon
                component={RefreshOutlinedIcon}
                color="disabled"
                style={{
                  fontSize: "1.8em",
                  color: "gray",
                  marginRight: "7px"
                }}
              ></SvgIcon>
              <span style={{ fontSize: "1.4em" }}>재촬영</span>
            </div>
          </div>

          <div className="driver-info">
            <div className="driver-name">이름</div>
            <div
              className="info-wrap"
              onClick={() => {
                setKeyBoardInfo({ keyboardShow: true, keyboardType: "text" });
                setKeyboardInput((prev) => ({
                  ...prev,
                  keyboardTypeName: "driverName",
                  keyboardDecript: "주 운전자 “이름”을 입력하세요.",
                  keyboardInputValue: driverValue.driverName
                }));

                hangulArr.length = 0; // hangulArr 초기화
                hangulArr.push(...hangul.disassemble(driverValue.driverName)); // 기존 driverName을 분해해서 채워줌
              }}
            >
              <div style={{ width: "47%", textAlign: "left", marginLeft: "1em" }}>
                {driverValue.driverName}
              </div>

              <div className="driver-update">
                <SvgIcon
                  component={BorderColorOutlinedIcon}
                  color="disabled"
                  style={{
                    fontSize: "1.5em",
                    color: "white",
                    marginRight: "7px"
                  }}
                ></SvgIcon>
                수정
              </div>
            </div>
          </div>
          <div className="driver-info">
            <div className="driver-name">생년월일</div>
            <div
              className="info-wrap"
              onClick={() => {
                setKeyBoardInfo({ keyboardShow: true, keyboardType: "number" });
                setKeyboardInput((prev) => ({
                  ...prev,
                  keyboardTypeName: "birthday",
                  keyboardDecript: "주 운전자 “생년월일”를 6자리를 입력하세요.",
                  keyboardInputValue: driverValue.birthday
                }));
              }}
            >
              <div
                style={{ width: "47%", textAlign: "left", marginLeft: "1em" }}
              >
                {" "}
                {driverValue.birthday.length === 6
                  ? formatDate(driverValue.birthday)
                  : driverValue.birthday}
              </div>
              <div className="driver-update">
                <SvgIcon
                  component={BorderColorOutlinedIcon}
                  color="disabled"
                  style={{
                    fontSize: "1.5em",
                    color: "white",
                    marginRight: "7px"
                  }}
                ></SvgIcon>
                수정
              </div>
            </div>
          </div>
          <div className="driver-info">
            <div className="driver-name">면허종류</div>
            <div
              className="info-wrap"
              onClick={() => {
                setDriverSelectShow(true);
              }}
            >
              <div
                style={{ width: "47%", textAlign: "left", marginLeft: "1em" }}
              >
                {" "}
                {driverValue.licenseType ? (
                  formatLicenseName(
                    formatLicenseType(driverValue.licenseType || "")
                  )
                ) : (
                  <div style={{ color: "red" }}>
                    운전자 면허종류를 선택해주세요.
                  </div>
                )}
              </div>
              <div className="driver-update">
                <SvgIcon
                  component={BorderColorOutlinedIcon}
                  color="disabled"
                  style={{
                    fontSize: "1.5em",
                    color: "white",
                    marginRight: "7px"
                  }}
                ></SvgIcon>
                수정
              </div>
            </div>
          </div>

          <div className="driver-info">
            <div className="driver-name">면허번호</div>
            <div
              className="info-wrap"
              onClick={() => {
                setKeyBoardInfo({ keyboardShow: true, keyboardType: "number" });
                setKeyboardInput((prev) => ({
                  ...prev,
                  keyboardTypeName: "licenseNum",
                  keyboardDecript: "주 운전자 “면허번호”를 입력하세요.",
                  keyboardInputValue: driverValue.licenseNum
                }));
              }}
            >
              <div
                style={{ width: "47%", textAlign: "left", marginLeft: "1em" }}
              >
                {driverValue.licenseNum ? (
                  addHyphenToLicenseNumber(driverValue.licenseNum)
                ) : (
                  <div style={{ color: "red" }}>
                    운전자 면허번호를 입력해주세요.
                  </div>
                )}
              </div>
              <div className="driver-update">
                <SvgIcon
                  component={BorderColorOutlinedIcon}
                  color="disabled"
                  style={{
                    fontSize: "1.5em",
                    color: "white",
                    marginRight: "7px"
                  }}
                ></SvgIcon>
                수정
              </div>
            </div>
          </div>

          <div className="driver-info">
            <div className="driver-name">면허검증</div>
            <div className="info-wrap">
              <div
                style={{
                  width: "15%",
                  textAlign: "center",
                  fontWeight: "600",
                  marginLeft: "1em",
                  padding: "5px",
                  background: "#F6F7FB",
                  borderRadius: "0.3em",
                  border: "1.5px solid #E4E7EC"
                }}
              >
                {driverValue.licenseCerti ? (
                  <span style={{ color: "#3E83F1" }}>인증 완료</span>
                ) : (
                  <span style={{ color: "#FF5353" }}>인증 안됨</span>
                )}
              </div>
              {!driverValue.licenseCerti && (
                <div
                  className="driver-certification"
                  onClick={() => {
                    directDlvLicense();
                  }}
                >
                  <SvgIcon
                    component={VerifiedOutlinedIcon}
                    color="disabled"
                    style={{
                      fontSize: "1.5em",
                      color: "white",
                      marginRight: "7px"
                    }}
                  ></SvgIcon>
                  인증
                </div>
              )}
            </div>
          </div>

          <div className="driver-info">
            <div className="driver-name">연락처</div>
            <div
              className="info-wrap"
              onClick={() => {
                setKeyBoardInfo({ keyboardShow: true, keyboardType: "number" });
                setKeyboardInput((prev) => ({
                  ...prev,
                  keyboardTypeName: "tel",
                  keyboardDecript: "주 운전자 “연락처”를 입력하세요.",
                  keyboardInputValue: driverValue.tel
                }));
              }}
            >
              <div
                style={{ width: "47%", textAlign: "left", marginLeft: "1em" }}
              >
                {driverValue.tel ? (
                  formatPhoneNumber(driverValue.tel)
                ) : (
                  <div style={{ color: "red" }}>
                    운전자 전화번호를 입력해주세요.
                  </div>
                )}
              </div>
              <div className="driver-update">
                <SvgIcon
                  component={BorderColorOutlinedIcon}
                  color="disabled"
                  style={{
                    fontSize: "1.5em",
                    color: "white",
                    marginRight: "7px"
                  }}
                ></SvgIcon>
                수정
              </div>
            </div>
          </div>

          <div
            className="driver-info"
            style={{ borderBottom: "2px solid #e4e7ec" }}
          >
            <div className="driver-name">비상연락처</div>
            <div
              className="info-wrap"
              onClick={() => {
                setKeyBoardInfo({ keyboardShow: true, keyboardType: "number" });
                setKeyboardInput((prev) => ({
                  ...prev,
                  keyboardTypeName: "emContactNumber",
                  keyboardDecript: "비상 연락처를 입력하세요.",
                  keyboardInputValue: driverValue.emContactNumber
                }));
              }}
            >
              <div
                style={{
                  width: "47%",
                  textAlign: "left",
                  marginLeft: "1em"
                }}
              >
                {driverValue.emContactNumber ? (
                  formatPhoneNumber(driverValue.emContactNumber)
                ) : (
                  <div style={{ color: "red" }}>비상연락처를 입력해주세요.</div>
                )}
              </div>
              <div className="driver-update">
                <SvgIcon
                  component={BorderColorOutlinedIcon}
                  color="disabled"
                  style={{
                    fontSize: "1.5em",
                    color: "white",
                    marginRight: "7px"
                  }}
                ></SvgIcon>
                수정
              </div>
            </div>
          </div>
          <div className="driver2-regis">
            {/* <span>부 운전자 등록하지 않는 경우 비상연락처를 입력해주세요!</span> */}
            <div
              className="btn-wrap"
              style={{
                width: "30%",
                fontSize: "10px"
              }}
            >
              <button
                onClick={() => {
                  driver2Regist();
                }}
                style={{
                  background: "white",
                  color: "#3e83f1",
                  borderRadius: "2em",
                  border: "2px solid #3e83f1",
                  boxShadow: "none"
                }}
              >
                {driverInfo && driverInfo[1] ? "부 운전자 정보 보기" : "부 운전자 등록하기 +" }
              </button>
            </div>
          </div>
        </div>
        <div className="btn-wrap" style={{ width: "100%" }}>
          <button
            onClick={() => {
              NextButton();
            }}
          >
            다음 단계로
          </button>
        </div>
      </div>
      {keyboardInfo.keyboardShow && (
        <div>
          <KeyboardWrap
            type={keyboardInfo.keyboardType}
            onClick={updateDriver}
            layoutName={layoutName}
            driverNameInput={keyboardInput.keyboardInputValue}
            titleDec={keyboardInput.keyboardDecript}
            onKeyPress={onKeyPress}
            onClose={() => {
              setKeyboardInput((prev) => ({ ...prev, keyboardInputValue: "" }));
              setKeyBoardInfo({ keyboardShow: false });
            }}
          ></KeyboardWrap>
        </div>
      )}
      {driverSelectShow && (
        <LisenceSelect
          licenseType={driverValue.licenseType}
          onClick={LisenceClick}
          onClose={selectOnClose}
        ></LisenceSelect>
      )}
      {adminKeyboard.keyboardShow && (
        <AdminKeyboard
          title="운전경력 확인을 위해 직원을 호출해주세요."
          companyId={resInfo?.data?.companyId}
          show={adminKeyboard.keyboardShow}
          onClose={() => {
            setAdminKeyboard(prev => ({ ...prev, keyboardShow: false }))
          }}
          onCallback={adminCheckPopCallback}
        ></AdminKeyboard>
      )}
      <input type="hidden" name="companyId" id="companyId" value={resInfo?.data?.companyId}></input>
      <input type="hidden" name="licenseScanWaitStatus" id="licenseScanWaitStatus" value="false"></input>
      <input type="hidden" name="licenseScanReturnMsg" id="licenseScanReturnMsg" value=""></input>
      <input type="hidden" name="kioskOperation" id="kioskOperation" value=""></input>
      <input type="hidden" name="licenseScanTimeout" id="licenseScanTimeout" value=""></input>
      <input type="hidden" name="driverName[0]" id="driverName[0]" value=""></input>
      <input type="hidden" name="birthday[0]" id="birthday[0]" value=""></input>
      <input type="hidden" name="licenseType[0]" id="licenseType[0]" value=""></input>
      <input type="hidden" name="licenseNum[0]" id="licenseNum[0]" value=""></input>
      <input type="hidden" name="address[0]" id="address[0]" value=""></input>
      <input type="hidden" name="kioskRequestOperation" id="kioskRequestOperation" value=""></input>
      <input type="hidden" name="kioskRequestOperationParam" id="kioskRequestOperationParam" value=""></input>
      <input type="hidden" name="reservationId" id="reservationId" value=""/>
      <input id="scanTarget" value="driverInfo01" type="hidden"></input>
    </>
  );
};

export default DriverInfo1;
